<div class="chat-box-messages">
  <ng-container *ngFor="let message of messages; let i = index; trackBy: messageIdTracker">
    <div class="chat-message" *ngIf="message.content" #chatMessage [class.sender]="message?.senderType === chatRoleEnum.ADMIN">
      <div class="chat-message__header">
        <div class="name">{{ message?.senderType === chatRoleEnum.ADMIN ? ('ChatBox.You' | translate) : message?.firstName }}</div>
        <div class="time">{{ message?.createdAt | date: dateFormat }}</div>
      </div>
      <div class="chat-message__text" [innerText]="message.content"></div>
    </div>
  </ng-container>
</div>